export default class ShuffleImages {
  private images: NodeListOf<HTMLElement>;
  private activeIndex = 0;
  private timer = 300;
  private pauseDuration = 1000;

  constructor(images: NodeListOf<HTMLElement>, timer: number, pauseDuration: number) {
    this.images = images;
    this.timer = timer;
    this.pauseDuration = pauseDuration
    this.init();
  }

  private init() {
    this.hideAllImages();
    this.shuffleImages();
  }

  private hideAllImages() {
    this.images.forEach((image) => {
      image.style.display = 'none';
    });
  }

  private showImage(index: number) {
    this.images[index].style.display = 'block';
  }

  private hideImage(index: number) {
    this.images[index].style.display = 'none';
  }

  private shuffleImages() {
    this.showImage(this.activeIndex);

    const interval = setInterval(() => {
      this.hideImage(this.activeIndex);
      this.activeIndex = (this.activeIndex + 1) % this.images.length;
      this.showImage(this.activeIndex);

      if (Math.random() > 0.7) {
        clearInterval(interval);
        setTimeout(() => this.shuffleImages(), this.pauseDuration);
      }
    }, this.timer);
  }
}
